export default [
  {
    path: '/ebook/list',
    name: 'ebookList',
    component: () => import('@/views/ebook/list/index.vue'),
    meta: {
      title: '车辆说明书',
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/ebook/pdf/:id',
    name: 'ebookPdf',
    component: () => import('@/views/ebook/pdf/index.vue'),
    meta: {
      title: 'PDF',
      backgroundClass: 'bg-black',
    },
  },
];
